<template>
    <div class="transaction_h">
        <div class="tab_box">
            <div :class="form.state==1?'active':''" @click="change_state(1)">{{$t("new1_txt.Settled")}}</div>
            <div :class="form.state==2?'active':''" @click="change_state(2)">{{$t("new1_txt.Unsettled")}}</div>
        </div>

        <div class="t_h1">
            <div class="t_h1_top">{{ $t("main.text322") }}</div>
            <div class="t_h1_box">
                <el-form class="zdy_form" label-position="top" :model="form">
                    <el-form-item :label="$t('main.text99')" class="riqi_box">
                        <el-date-picker popper-class="time_box month_box" :clearable="false" :editable="false" v-model="form.time" type="month" :format="v_lan == 'en' ? 'MM/yyyy' : 'yyyy/MM'" value-format="yyyy-MM" range-separator="-" :placeholder="month_pld" @change="month_change" :picker-options="pickerOptions_4">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="btn_box">
                        <el-button class="reset_btn border_set_color" size="medium" @click="reset_btn">{{ $t("main.text329") }}</el-button>
                        <el-button class="apply_btn" size="medium" @click="apply_btn">
                            {{$t("main.text330")}}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="t_h2">
            <div class="t_h2_box">
                <div>
                    <div class="t_h2_txt1">{{ $t("main.text270") }}</div>
                    <!-- <div class="t_h2_txt2"></div> -->
                </div>
                <div class="t_h2_box_button">
                    <!-- <img src="../../assets/img/Vector1.png" alt="" @click="showCardStatementList" class="pdfBtn" /> -->
                    <el-button class="export_btn border_set_color2" icon="el-icon-download" size="medium" @click="download_btn">{{$t('main.text333')}}</el-button>
                </div>
            </div>
            <div class="t_h2_table zdy_tab_header">
                <!-- <el-table :data="tableData" stripe style="width: 100%"> -->
                <el-table :data="tableData.slice((page - 1) * limit, page * limit) " stripe style="width: 100%">
                    <el-table-column :label="$t('main.text99')">
                        <span slot-scope="props">
                            <!-- {{ overall_time(props.row.c_time) }} -->
                            {{set_time( props.row.date )}}
                        </span>
                    </el-table-column>
                    <el-table-column :label="$t('main.text658')">
                        <span slot-scope="props">
                        <div>{{props.row.number}}</div>
                        </span>
                    </el-table-column>
                    <el-table-column :label="$t('main.text710')">
                        <span slot-scope="props">
                            {{ props.row.description||"-"}}
                        </span>
                    </el-table-column>
                    <el-table-column :label="$t('bank_card.describe')">
                        <span slot-scope="props">
                            {{ props.row.detail||"-"}}
                        </span>
                    </el-table-column>
                    <el-table-column :label="$t('main.text314')">
                        <span slot-scope="props">
                            {{ props.row.base_amount }}
                        </span>
                    </el-table-column>
                    <!-- <el-table-column :label="$t('main.text711')">
                        <span slot-scope="props">
                            {{ props.row.transaction_total }}
                        </span>
                    </el-table-column> -->
                    <el-table-column :label="$t('main.text712')">
                        <span slot-scope="props">
                            {{ props.row.transaction_id }}
                        </span>
                    </el-table-column>
                </el-table>
                <el-pagination v-if="tableData.length > 0" background :page-sizes="[10, 20, 30, 40]" :page-size="limit" :current-page.sync="currentPage" layout="prev, pager, next" :total="page_total" @current-change="current_change"></el-pagination>
            </div>
        </div>
        <!-- pdf -->
        <div class="download_pdf_box pdf_location">
            <PDF :dataDetail="pdfList" :y="y" :m="m" :d="d" :total="total" :number="number" />
            <div class="pdf-header">
                <div class="pdf-header1">
                    <div class="header-title">
                        <span v-if="v_lan == 'ch'" class="ch-title">{{ $t('pdf.text1') }}</span>
                        <span>{{ lang_en.pdf.text1 }}</span>
                    </div>
                    <div class="header-subtitle">
                        <span v-if="v_lan == 'ch'" class="ch-title">{{ $t('pdf.text2') }}</span>
                        <span>{{ lang_en.pdf.text2 }}</span>
                    </div>
                </div>
                <div class="pdf-header3">
                    <img src="../../assets/img/pdf_logo.png" alt="" />
                    <div class="sub-title">
                        <span v-if="v_lan == 'ch'" class="ch-title">{{ $t('pdf.text12') }}</span>
                        <span id="page">{{ lang_en.pdf.text12 }} 1 of 3</span>
                    </div>
                </div>
            </div>
            <div class="pdf-footer">
                <div class="pdf-footer-div" style="padding-top: 5px">
                    <div>VDC_ESTMT_3495029302_20221231_XXXX_94920</div>
                    <div style="margin-top: 4px;">www.bethfinance.com</div>
                </div>
            </div>
        </div>
        <!-- pdf 弹框 -->
        <el-dialog :title="$t('main.text780')" :visible.sync="pdf_dlg" custom-class="dlg element_input pdf_dlg card_dlg" append-to-body width="750px">
            <div class="dlg_body">
                <div class="pdf_body">
                    <div class="p_item" v-for="(item, index) in dateList" :key="index">
                        <div>
                            <div class="p_t1" v-if="v_lan != 'ch'">
                                {{ item.Month | current_month }} {{ item.Year }}
                            </div>
                            <div class="p_t1" v-else>
                                {{ item.Year }} 年 {{ item.Month }} 月
                            </div>
                            <!-- <div class="p_t2">{{ $t("main.text781") }}</div> -->
                        </div>
                        <div>
                            <img @click="getTransactionStatement(item.Year, item.Month)" class="p_icon" src="@/assets/img/down_pdf.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import moment from 'moment'
import { transactionDetails, transactionDownload, transaction_statement } from "@/api/api";
import lang_en from "@/language/en";
import PDF from "./pdf.vue";
import { outputPDF } from "@/utils/outputPDF";

export default {
    filters: {
        current_month(v) {
            let en_mon_arr = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Spt",
                "Oct",
                "Nov",
                "Dec",
            ];
            return en_mon_arr[v - 1];
        },
        current_description(v, v_lan) {
            if (/LOAD_CARD/.test(v)) {
                if (v_lan == 'ch') {
                    return '充值';
                } else {
                    return 'TOP-UP';
                }
            } else if (/COMPRAS/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款消费';
                } else {
                    return 'DR PURCHASES';
                }
            } else if (/RETIROS/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款';
                } else {
                    return 'DR WITHDRAWALS';
                }
            } else if (/RETIRO DE EFECTIVO/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款提现';
                } else {
                    return 'DR CASH WITHDRAWAL';
                }
            } else if (/SEGUROS/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款保险';
                } else {
                    return 'DR INSURANCE';
                }
            } else if (/PAGOS/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款支付';
                } else {
                    return 'DR PAYMENTS';
                }
            } else if (/FUNDS "CLAWBACK"/.test(v) || /EXCESS LOAD/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款补扣';
                } else {
                    return 'DR TOP-UP REVERSAL';
                }
            } else if (/REVERSION DE DEVOLUCION/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款撤销';
                } else {
                    return 'DR RETURN REVERSAL';
                }
            } else if (/LOCAL TAX/.test(v) || /COBRO DE ITBMS/.test(v)) {
                if (v_lan == 'ch') {
                    return '税务费用';
                } else {
                    return 'FEE TAX';
                }
            } else if (/COMISION COMPRA POS\/ONLINE/.test(v)) {
                if (v_lan == 'ch') {
                    return '固定费用';
                } else {
                    return 'FEE FLAT';
                }
            } else if (/COMISIÓN TRANS\. INT\. % Aut\./.test(v)) {
                if (v_lan == 'ch') {
                    return '汇率% 费用';
                } else {
                    return 'FEE FX%';
                }
            } else if (/COMISION RETIRO ATM/.test(v)) {
                if (v_lan == 'ch') {
                    return '取款机固定费用';
                } else {
                    return 'FEE ATMF';
                }
            } else if (/COMISION % RETIRO ATM/.test(v)) {
                if (v_lan == 'ch') {
                    return '取款机% 费用';
                } else {
                    return 'FEE ATM%';
                }
            } else if (/COMISION RETIRO DE EFECTIVO/.test(v)) {
                if (v_lan == 'ch') {
                    return '提现费用';
                } else {
                    return 'FEE CASH WITHDRAWAL';
                }
            } else if (/CARGO POR EMISION DE PIN/.test(v)) {
                if (v_lan == 'ch') {
                    return '密码发行费用';
                } else {
                    return 'FEE PIN ISSUANCE';
                }
            } else if (/CARGO POR INVESTIGACION RECLAMOS/.test(v)) {
                if (v_lan == 'ch') {
                    return '调查费用';
                } else {
                    return 'FEE CLAIMS INVESTIGATION';
                }
            } else if (/MEMBRESIA TARJETA ADICIONAL/.test(v)) {
                if (v_lan == 'ch') {
                    return '会员+ 费用';
                } else {
                    return 'FEE ADDTL CARD MEMBERSHIP';
                }
            } else if (/MEMBRESIA TARJETA TITULAR/.test(v)) {
                if (v_lan == 'ch') {
                    return '会员费用';
                } else {
                    return 'FEE CARD MEMBERSHIP';
                }
            } else if (/RENOVACION ANUAL TARJETA ADICIONAL/.test(v)) {
                if (v_lan == 'ch') {
                    return '年费+ 费用';
                } else {
                    return 'FEE ADDTL CARD ANNUAL RENEWAL';
                }
            } else if (/RENOVACION ANUAL TARJETA TITULAR/.test(v)) {
                if (v_lan == 'ch') {
                    return '年费 费用';
                } else {
                    return 'FEE CARD ANNUAL RENEWAL';
                }
            } else if (/CARGO POR REPOSICION DE TARJETA/.test(v)) {
                if (v_lan == 'ch') {
                    return '费用';
                } else {
                    return 'FEE CARD REPLACE';
                }
            } else if (/DEVOLUCION DE COMPRAS/.test(v)) {
                if (v_lan == 'ch') {
                    return '消费退款存入';
                } else {
                    return 'CR PURCHASE RETURNS';
                }
            } else if (/REVERSION DE COMPRA/.test(v)) {
                if (v_lan == 'ch') {
                    return '消费撤销存入';
                } else {
                    return 'CR PURCHASE REVERSAL';
                }
            } else if (/REVERSION DE PAGO/.test(v)) {
                if (v_lan == 'ch') {
                    return '支付撤销存入';
                } else {
                    return 'CR PAYMENT REVERSAL';
                }
            } else if (/REVERSION DE RETIRO/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款撤销存入';
                } else {
                    return 'CR WITHDRAWAL REVERSAL';
                }
            } else if (/AJUSTE POR RECLAMOS RETIROS/.test(v)) {
                if (v_lan == 'ch') {
                    return '理赔调整';
                } else {
                    return 'CLAIMS ADJ';
                }
            } else {
                return v;
            }
        },
    },
    components: {
        PDF
    },
    data() {
        return {
            form: {
                time: "",
                state:1,
            },
            time_list: [],
            id: '',
            currentPage: 1,
            page: 1, //分页 从 1 开始
            limit: 10, //每页条数
            page_total: 0, //一共多少条
            tableData: [],
            // 日期只可以是当前往前4个月
            // 卡交易记录，之前限制的是4个月，现在换成6个月
            pickerOptions_4: {
                disabledDate(time) {
                    let now = new Date(); //当前日期
                    let nowMonth = now.getMonth() + 1; //当前月份
                    let nowYear = now.getFullYear(); //当前年
                    // 开始月份
                    let startMonth = new Date(nowYear, nowMonth - 7, 1);
                    // 结束月份
                    let endMonth = new Date(nowYear, nowMonth, 0);
                    return time.getTime() < startMonth || time.getTime() > endMonth;
                }
            },
            month_pld: '',
            dateList: [],
            pdf_dlg: false,
            pdfList: {},
            lang_en: lang_en,
            y: '',
            m: '',
            d: '',
            total: 0,
            number: ''
        };
    },
    beforeDestroy() {
        sessionStorage.removeItem("top_title_name");
    },
    beforeMount() {
        this.id = this.$route.query.id;
        this.number = this.$route.query.number;
    },
    mounted() {
        let activeTime = this.$route.query.time;
        let activeYear = 0;
        let activeMonth = 0;
        if (activeTime) {
            let time = new Date(+activeTime);
            activeYear = time.getFullYear();
            activeMonth = time.getMonth() + 1;
        }
        let dateList = [];
        let date = new Date();
        let Year = date.getFullYear();
        let Month = date.getMonth() + 1;
        for (let i = 0; i < 6; i++) {
            Month--;
            if (Month == 0) {
                Month = 12;
                Year = Year - 1;
            }
            if (activeYear && activeMonth) {
                if (Year < activeYear) break;
                if (Year == activeYear && Month < activeMonth) break;
            }
            dateList.push({ Year, Month });
        }
        this.dateList = dateList;
        let card_num = this.number?this.number.substr(12,4):'';
        // sessionStorage.setItem("top_title_name", this.$t("main.text270")+"-"+card_num);
        sessionStorage.setItem("top_title_name",card_num?'****'+card_num:"-");
        this.get_list();
        this.set_month();
    },
    methods: {
        get_list() {
            let date = new Date();
            transactionDetails({
                card_id: this.id,
                year: this.time_list.length ? this.time_list[0] * 1 : date.getFullYear(),
                month: this.time_list.length ? this.time_list[1] * 1 : date.getMonth() + 1,
                state: this.form.state,
            }).then((res) => {
                if (res.data.code == 200) {
                    // console.log(res.data.data);
                    this.page_total = res.data.data.length;
                    this.tableData = res.data.data;
                } else {
                    this.message.ismessage('error', res.data.msg);
                }
            });
        },
        change_state(v){
            this.form.state = v;
            this.get_list();
        },
        reset_btn() {
            this.time_list = [];
            this.form.time = "";
            // this.form.state = 1;
            this.page = 1;
            this.limit = 10;
            this.currentPage = 1;
            this.get_list();
            this.set_month();
        },
        apply_btn() {
            // console.log(this.form);
            this.page = 1;
            this.limit = 10;
            this.currentPage = 1;
            this.get_list();
        },
        current_change(v) {
            // console.log(v);
            this.page = v;
            this.limit = 10;
            // this.get_list();
        },
        download_btn() {
            if (this.page_total <= 0) {
                return this.message.ismessage('error', this.$t('main.text335'));
            }
            let date = new Date();
            transactionDownload({
                card_id: this.id,
                year: this.time_list.length ? this.time_list[0] * 1 : date.getFullYear(),
                month: this.time_list.length ? this.time_list[1] * 1 : date.getMonth() + 1,
                state: this.form.state,
            }).then(res => {
                const filename = res.headers['content-disposition'].split(';')[1].split('=')[1] || 'download.xlsx';
                const link = document.createElement('a')
                const blob = new Blob([res.data], { type: 'application/octet-stream' })
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                // link.setAttribute('download', `download.xlsx`)
                link.setAttribute('download', `${filename}`)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
        },
        set_time(v) {
            // v;
            // 07/10/2022----2022/10/07
            if (this.v_lan == 'ch') {
                let str = v.split("/");
                return str[2] + "/" + str[1] + "/" + str[0];
            } else {
                return v;
            }

        },
        month_change(v) {
            this.time_list = v.split('-');
            // console.log(v);
            // console.log(this.time_list);
        },
        set_month() {
            let now = new Date(); //当前日期
            let nowMonth = now.getMonth() + 1; //当前月份
            let nowYear = now.getFullYear(); //当前年
            let time = '';
            if (this.v_lan == 'ch') {
                time = `${nowYear}/${nowMonth<10?'0'+nowMonth:nowMonth}`;
            } else {
                time = `${nowMonth<10?'0'+nowMonth:nowMonth}/${nowYear}`;
            }
            if (time) {
                this.month_pld = time;
            }
        },
        showCardStatementList() {
            this.pdf_dlg = true;
        },
        async getTransactionStatement(year, month) {
            const that = this;
            let params = {
                card_id: this.id,
                year: year,
                month: month
            }
            that.y = year;
            that.m = month;
            that.d = moment(`${year}-${month}-01`).endOf('month').get('date');
            await transaction_statement(params).then((res) => {
                if (res.data.code == 200) {
                    that.pdfList = res.data.data;
                    for (let i = 0; i < that.pdfList.list.length; i++) {
                        that.total += +(that.pdfList.list[i].base_amount);
                    }
                    if (that.total) {
                        that.total = that.total.toFixed(2);
                    }
                }
            });
            const element = document.querySelector(".download_pdf_box");
            const header = document.querySelector(".pdf-header");
            const footer = document.querySelector(".pdf-footer");
            try {
                await outputPDF({
                    element: element,
                    footer: footer,
                    header: header,
                    contentWidth: 560,
                });
            } catch (error) {
                this.$message.error(
                    typeof error === "string" ? error : JSON.stringify(error)
                );
            }
        }
    },
};
</script>
<style scoped>
.t_h1_top {
    margin-top: 40px;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 16px;
}

.t_h1_box {
    background: #232A36;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 28px;
    padding-bottom: 6px;
}

.zdy_form>>>.el-form-item {
    display: inline-block;
    width: 252px;
    margin-right: 20px;
}

.zdy_form>>>.el-date-editor.el-input,
.zdy_form>>>.el-select {
    width: 100%;
}

.zdy_form>>>.el-form-item:last-child {
    margin-right: 0;
}

.zdy_form>>>.el-form-item__label {
    padding: 0;
    line-height: inherit;
    margin-bottom: 8px;
    color: rgba(255, 255, 255, 0.6);
}

.zdy_form>>>.el-input__inner {
    background: #333A47;
    border: none;
    border-radius: 8px;
    color: #fff;
}

.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus {
    min-width: 140px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: #BBBBBB;
    background: transparent;
    border: 1.25px solid #BBBBBB;
    border-radius: 4px;
}

.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus {
    min-width: 140px;
    border-color: #00C18E;
    background: #00C18E;
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: #191E29;
}

.zdy_form .btn_box {
    width: auto;
}

.t_h2_box {
    display: flex;
    justify-content: space-between;
    margin-top: 80px;
    align-items: center;
}

.t_h2_txt1 {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 4px;
}

.t_h2_txt2 {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.8);
}

.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus {
    min-width: 136px;
    color: #00C18E;
    border-color: #00C18E;
    border-style: solid;
    border-width: 1.5px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    min-width: 120px;
    background: transparent;
}

.icon_width {
    width: 20px;
    vertical-align: middle;
    cursor: pointer;
}

.color_red {
    color: #f35f65;
}

.t_h2_box_button {
    display: flex;
    align-items: center;
}

.pdfBtn {
    height: 40px;
    margin-right: 20px;
    cursor: pointer;
}

.t_h2_button {
    margin-right: 14px;
    padding: 6px 10px;
    border: 3px solid #FFEB3B;
    border-radius: 8px;
    color: #FFEB3B;
    font-size: 16px;
    cursor: pointer;
}

.dlg_body {
    border-radius: 0 0 16px 16px;
}

.pdf_body {
    box-sizing: border-box;
    padding: 40px 50px;
}

.p_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #314b69;
    padding-bottom: 15px;
    margin-bottom: 15px;
    color: #fff;
}

.p_t1 {
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 5px;
}

.p_t2 {
    font-weight: 400;
    font-size: 13px;
    opacity: 0.6;
}

.p_icon {
    width: 20px;
    vertical-align: middle;
    cursor: pointer;
    margin-right: 5px;
}

.pdf_location {
    color: #000;
    position: fixed;
    top: 0;
    left: 0;
    transform: translateX(-100%);
    background: #fff;
    z-index: 2;
    width: 900px;
}

.pdf-footer {
    width: 1000px;
    position: fixed;
    background: #fff;
    top: -100vh;
}

.pdf-footer .pdf-footer-div {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
    margin: 20px 60px;
    font-weight: 400;
    font-size: 12px;
    color: #000000;
}

.pdf-footer .pdf-footer-div div {
    text-align: center;
    font-family: Outfit;
    font-weight: 400;
}

.pdf-header {
    width: 1000px;
    position: fixed;
    top: -100vh;
    background: #FFF;
    display: flex;
    justify-content: space-between;
}

.pdf-header .pdf-header1 {
    margin-top: 56px;
    margin-bottom: 20px;
    margin-left: 60px;
    margin-right: 60px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.pdf-header .pdf-header1 .header-title {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #000000;
}

.pdf-header .pdf-header1 .header-title .ch-title {
    margin-right: 8px;
    font-family: 'Noto_Sans_SC_Medium'
}

.pdf-header .pdf-header1 .header-title span {
    font-family: Outfit3;
}

.pdf-header .pdf-header1 .header-subtitle {
    font-size: 12px;
    color: #000000;
}

.pdf-header .pdf-header1 .header-subtitle .ch-title {
    margin-right: 8px;
    font-family: 'Noto_Sans_SC_Regular'
}

.pdf-header .pdf-header1 .header-subtitle span {
    font-family: Outfit4;
}

.pdf-header .pdf-header3 {
    margin-top: 20px;
    margin-right: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.pdf-header .pdf-header3 img {
    width: 150px;
}

.pdf-header .pdf-header3 .sub-title {
    margin-top: 12px;
    font-family: Outfit;
    font-size: 12px;
    font-weight: 400;
    color: #000000;
}

.pdf-header .pdf-header3 .sub-title .ch-title {
    margin-right: 8px;
}
.tab_box{
    display: flex;
    border-bottom: 1px solid #314B69;
}
.tab_box>div{
    margin-right: 20px;
    cursor: pointer;
}
.active{
  font-style: normal;
  font-weight: 700;
  color: #00C18E;
  border-bottom: 3px solid #00C18E;
  padding-bottom: 4px;
}
</style>
<style>
.month_box .el-month-table td .cell {
    color: #fff;
}

.month_box .el-month-table td.disabled .cell {
    color: #C0C4CC;
}

@media screen and (max-width: 850px) {
    .month_box {
        left: 6% !important;
        width: 87% !important;
    }
}
</style>
<style scoped>
@media screen and (max-width: 850px) {
    .t_h1_top {
        margin-top: 0;
    }

    .t_h2_box {
        margin-top: 40px;
        align-items: flex-start;
    }
}
</style>
<style>
.pdf_dlg .el-dialog__title {
    margin-left: 50px;
}
</style>